module.exports = __webpack_public_path__ + "img/img-01@2x.57cab1fc.png";